// src/marketing/launch/TaskRow.tsx
import type { LaunchTask } from '../../lib/types'
import { Chip } from '../editorial/Chip'
import { launchTaskDate } from './dates'

type Props = {
  task: LaunchTask
  launchDate: string | null
  onToggle: (id: string, done: boolean) => void
  onEdit: (task: LaunchTask) => void
  onDelete: (id: string) => void
}

export function TaskRow({ task, launchDate, onToggle, onEdit, onDelete }: Props) {
  const dateLabel = launchTaskDate(launchDate, task.dayOffset)
  const checkboxId = `task-checkbox-${task.id}`

  return (
    <li className="xt">
      <label htmlFor={checkboxId} style={{ display: 'flex', gap: '13px', alignItems: 'baseline', cursor: 'pointer', minWidth: 0 }}>
        <span className="xcb">
          <input
            id={checkboxId}
            type="checkbox"
            data-testid={checkboxId}
            checked={task.done}
            onChange={(e) => onToggle(task.id, e.target.checked)}
          />
          <span className="xbox" aria-hidden="true" />
        </span>
        <span className={`xtxt${task.done ? ' done' : ''}`}>
          {task.title}
          {task.detail && (
            <span className="task-detail" style={{ display: 'block', color: 'var(--muted)', fontSize: '0.8rem', fontWeight: 'normal', marginTop: '0.15rem' }}>
              {task.detail}
            </span>
          )}
        </span>
      </label>
      <div className="xmeta">
        {dateLabel && <Chip variant="date">{dateLabel}</Chip>}
        <button
          onClick={() => onEdit(task)}
          aria-label={`Modifier ${task.title}`}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--muted)',
            fontSize: '0.75rem',
            padding: '0.125rem 0.375rem',
            fontFamily: 'inherit',
          }}
        >
          ✎
        </button>
        <button
          onClick={() => onDelete(task.id)}
          aria-label={`Supprimer ${task.title}`}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--muted)',
            fontSize: '0.75rem',
            padding: '0.125rem 0.375rem',
            fontFamily: 'inherit',
          }}
        >
          ✕
        </button>
      </div>
    </li>
  )
}
